module.exports = __webpack_public_path__ + "static/media/YM88_3.4ce1acb3.jpg";